import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'extToPdf'})

export class ChangeExtension implements PipeTransform {
    transform(item) {
        if (item && !/(.+)(\.pdf)+$/.test(item)) {
            return item + '.pdf';
        }
        return item;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/pipes/extension-changer.pipe.ts